import useTranslation from "@hooks/use_translation.ts";
import { useSalaryOptions } from "@hooks/job_search/use_filter_options.ts";
import SectionDetailList from "@components/profile/section_detail_list.tsx";
import type { ProfileData } from "@/queries/use_profile.ts";

type Props = { data: ProfileData };

const VISIBLE_LANGUAGES = 2;

const WorkPreferencesBody = ({ data }: Props) => {
  const { t } = useTranslation("user", { keyPrefix: "profile_sections.work_preferences" });
  const salaryOptions = useSalaryOptions();
  const {
    location,
    willingToRelocate,
    salary,
    worksites,
    employmentTypes,
    languages,
    desiredJobTitles,
  } = data.workPreferences ?? {};
  const languagesValue = () => {
    if (!languages?.length) return null;

    const shown = languages.slice(0, VISIBLE_LANGUAGES);
    const remaining = languages.length - shown.length;

    return [
      ...shown,
      ...(remaining > 0 ? [t("languages_overflow", { count: remaining })] : []),
    ].join(", ");
  };

  return (
    <SectionDetailList
      rows={[
        { label: t("job_title"), value: desiredJobTitles?.join(", ") || null },
        { label: t("location"), value: location },
        {
          label: t("willing_to_relocate"),
          value:
            willingToRelocate == null
              ? null
              : willingToRelocate
                ? t("relocation_yes")
                : t("relocation_no"),
        },
        {
          label: t("salary"),
          value: salaryOptions.find((option) => option.value === salary)?.label,
        },
        { label: t("worksites"), value: worksites?.join(", ") },
        { label: t("employment_types"), value: employmentTypes?.join(", ") },
        { label: t("languages"), value: languagesValue() },
      ]}
    />
  );
};

export default WorkPreferencesBody;
